module.exports = __webpack_public_path__ + "img/lightwave.39754ec2.png";